/**
 * Formato de fechas del sistema: AM/PM con zona horaria de Colombia (America/Bogota).
 */

const TZ_COLOMBIA = 'America/Bogota';

/** Formato completo: dd/MM/yyyy, hh:mm a (ej. "18/03/2025, 3:30 p. m.") */
export function formatDateColombia(date: Date | string): string {
  return new Date(date).toLocaleString('es-CO', {
    timeZone: TZ_COLOMBIA,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

/** Solo hora: hh:mm a (ej. "3:30 p. m.") */
export function formatTimeColombia(date: Date | string): string {
  return new Date(date).toLocaleTimeString('es-CO', {
    timeZone: TZ_COLOMBIA,
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

/** Clave de fecha para agrupar: yyyy-MM-dd en Colombia */
export function getDateKeyColombia(date: Date | string): string {
  return new Date(date).toLocaleDateString('en-CA', { timeZone: TZ_COLOMBIA });
}

/** Encabezado para agrupar transacciones: "Hoy", "Ayer" o "lunes 18 de marzo, 2025" */
export function formatDateHeaderColombia(dateKey: string): string {
  const todayKey = getDateKeyColombia(new Date());
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayKey = getDateKeyColombia(yesterday);
  if (dateKey === todayKey) return 'Hoy';
  if (dateKey === yesterdayKey) return 'Ayer';
  const d = new Date(dateKey + 'T12:00:00-05:00');
  const str = d.toLocaleDateString('es-CO', {
    timeZone: TZ_COLOMBIA,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  return str.charAt(0).toUpperCase() + str.slice(1);
}
